module.exports = __webpack_public_path__ + "img/home-card1.874e0b6d.svg";